import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function WRCTA() {
  return <section className="bg-[#FF1493] py-[48px] lg:py-[80px]" data-id="element-2300">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2301">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-2302">
          <h2 className="text-[28px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-2303">
            READY TO BE UNEXPECTED?
          </h2>

          <p className="font-serif italic text-white/90 text-lg lg:text-xl mb-10" data-id="element-2304">
            Book your complimentary consultation today
          </p>

          <Button variant="white" size="lg" className="w-full sm:w-auto px-10 py-4 text-sm tracking-[2px] rounded uppercase text-[#FF1493] hover:bg-black hover:text-white transition-colors" data-id="element-2305">
            BOOK CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}